import { render, staticRenderFns } from "./AssignmentDisplayLink.vue?vue&type=template&id=5da22257&scoped=true&"
import script from "./AssignmentDisplayLink.vue?vue&type=script&lang=js&"
export * from "./AssignmentDisplayLink.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDisplayLink.vue?vue&type=style&index=0&id=5da22257&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da22257",
  null
  
)

export default component.exports